export const normalizeValue = (value: string) => {
  return value.trim().toLowerCase();
};
